import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BeneficiaryRoutingModule } from './beneficiary-routing.module';
import { BeneficiaryFooterComponent } from './Layout/beneficiary-footer/beneficiary-footer.component';
import {TranslateModule} from "@ngx-translate/core";
import {SimplebarAngularModule} from "simplebar-angular";
import { BeneficiarySideBarComponent } from './Layout/beneficiary-side-bar/beneficiary-side-bar.component';
import { BeneficiaryTopBarComponent } from './Layout/beneficiary-top-bar/beneficiary-top-bar.component';
import { BeneficiaryLayoutComponent } from './Layout/beneficiary-layout/beneficiary-layout.component';
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import { ChangeBenefPasswordComponent } from './Shared/Components/change-benef-password/change-benef-password.component';
import {UIModule} from "../../shared/ui/ui.module";
import {ReactiveFormsModule} from "@angular/forms";
import {LaddaModule} from "angular2-ladda";
import { SessionTimerService } from 'src/app/shared/session_service';


@NgModule({
  declarations: [
    BeneficiaryFooterComponent,
    BeneficiarySideBarComponent,
    BeneficiaryTopBarComponent,
    BeneficiaryLayoutComponent,
    ChangeBenefPasswordComponent
  ],
  exports: [
    ChangeBenefPasswordComponent
  ],
  imports: [
    CommonModule,
    BeneficiaryRoutingModule,
    TranslateModule,
    SimplebarAngularModule,
    NgbModule,
    UIModule,
    ReactiveFormsModule,
    LaddaModule
    
  ],
  providers: [
    SessionTimerService
  ]
})
export class BeneficiaryModule { }
